import { useDelay } from "@/components/hooks/useDelay";
import { cn } from "@/lib/utils";

export function Delayed({
  delay = 0,
  children,
}: {
  delay?: number;
  children: React.ReactNode;
}) {
  const show = useDelay(delay);

  return (
    <div
      className={cn(
        "flex items-center justify-center",
        "transition-opacity duration-200",
        show || delay === 0 ? "opacity-100" : "opacity-0",
      )}
    >
      {children}
    </div>
  );
}
